module.exports = __webpack_public_path__ + "img/i-close-gold.2bc64059.svg";